import { ActionType } from 'typesafe-actions'
import * as actions from '../actions/domains'
import { wdqlMergeOne, wdqlMergeSet } from '../util/remote/wdql'
import { DomainEntity } from '../types/entity-types'

const DomainReducer = (
  state: DomainEntity[] = [],
  action: ActionType<typeof actions>
) => {
  switch (action.type) {
    case actions.WDQL_MERGE_DOMAIN:
      return wdqlMergeOne(state, action.payload)
    case actions.WDQL_MERGE_DOMAINS:
      return wdqlMergeSet(state, action.payload)
    default:
      return state
  }
}

export default DomainReducer
